import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiServicesService } from '../services/api-services.service';
import { environment } from '../../envoirnments/environment';

@Component({
  selector: 'app-image-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-modal.component.html',
  styleUrl: './image-modal.component.css'
})

export class ImageModalComponent {

  imageUrl: string;
  isFullscreen = false;
  isZoomedIn = false;
  isShareVisible = false;

  constructor(
    public api: ApiServicesService,
    private dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.imageUrl = environment.baseUrl+data.imageUrl;
  }

  closeModal(): void {
    this.dialogRef.close();
    this.closeFullscreen();
  }

  share(platform: string): void {
    const encodedUrl = encodeURIComponent(this.imageUrl);
    
    if (!this.imageUrl || !this.imageUrl.startsWith('http')) {
      console.error('Invalid URL:', this.imageUrl);
      return;
    }
  
    const shareUrls: { [key: string]: string } = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
      pinterest: `https://www.pinterest.com/pin/create/button/?url=${encodedUrl}`
    };
  
    this.isShareVisible = false;
  
    // Ensure the platform is valid before opening the window
    if (shareUrls[platform]) {
      // console.log('Opening share URL:', shareUrls[platform]);
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    } else {
      console.error('Invalid platform specified:', platform);
    }
  }
  
  

  downloadImage(): void {
    this.isShareVisible=false;
    const link = document.createElement('a');
    link.href = this.imageUrl;
    link.download = 'image.png';
    this.isShareVisible = false;
    link.click();
  }

  zoomLevel: number = 1;

  get zoomStyle(): string {
    return `scale(${this.zoomLevel})`;
  }

  toggleZoom() {
    this.isShareVisible=false;
    if (this.isZoomedIn) {
      this.zoomLevel = 1;
    } else {
      this.zoomLevel = 3;
    }
    this.isZoomedIn = !this.isZoomedIn;
  }

  toggleShare() {
    this.isShareVisible = !this.isShareVisible;
  }

  toggleFullscreen() {
    this.isShareVisible=false;
    if (!this.isFullscreen) {
      this.openFullscreen();
    } else {
      this.closeFullscreen();
    }
  }

  openFullscreen() {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((<any>element).webkitRequestFullscreen) {
      (<any>element).webkitRequestFullscreen();
    } else if ((<any>element).msRequestFullscreen) {
      (<any>element).msRequestFullscreen();
    }
    this.isFullscreen = true;
  }

  closeFullscreen() {
    const doc: any = document;
  
    // Only try to exit if fullscreen is active
    if (
      doc.fullscreenElement ||
      doc.webkitFullscreenElement ||
      doc.msFullscreenElement
    ) {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
      this.isFullscreen = false;
    }
  }
}
